module.exports = __webpack_public_path__ + "img/la_v0.9b938011.png";